#import "../fragments/account-hierarchy-fragment.graphql"

query GetAccountHierarchy($id: ID!) {
    account(id: $id) {
        ...AccountHierarchyFragment
    }
}
